import { AttachmentContent } from '../models/AttachmentContent';
import { withUploadRejectionDetection } from '../../../helpers/uploadRequestRejection';
import { PDADataService } from '../../../services/base/PDADataService';

export class PDFAttachmentsJsonService extends PDADataService {
  protected prefixUrl: string = `PDFAttachments`;

  uploadFiles(folderId: number, files: File[]) {
    return Promise.all(files.map(x => new Promise<any>((resolve, reject) => {
      let reader = new FileReader();
      reader.onload = e => resolve({ file: x, data: e.target?.result });
      reader.onerror = e => reject({ file: x, error: e.target?.result });
      reader.readAsDataURL(x);
    }))).then(x => {
      let items = x.map(x => {
        let start = ';base64,';
        let i = x.data.indexOf(start);

        return <AttachmentContent>{
          Data: x.data.substring(i + start.length),
          Attachment: {
            Title: x.file.name,
            Type: x.data.substring(5, i),
            Size: x.file.size,
            StatusId: 2,
          }
        };
      });

      return this.api.post(`${this.prefixUrl}/UploadFilesJson?folderId=${folderId}`, items, withUploadRejectionDetection());
    })
  }
}
